import BaseClass from "./BaseClass";

class SharedCustomers extends BaseClass {
  constructor(data, skip_embedded = false) {
    super(data, skip_embedded);
    try {
      this._embedded.sharedContacts = this._embedded.sharedContacts.map(v => {
        v.customer_uuid = this.uuid;
        return v;
      });
    } catch (e) {}
  }

  get amocrm() {
    try {
      return this._embedded.sharedAmocrm;
    } catch (e) {
      return [];
    }
  }

  get countAmo() {
    try {
      return this.amocrm.length;
    } catch (e) {
      return 0;
    }
  }

  get contacts() {
    try {
      return this._embedded.sharedContacts;
    } catch (e) {
      return [];
    }
  }

  get countContacts() {
    try {
      return this.sharedContacts_uuids.length;
    } catch (e) {
      return 0;
    }
  }

  get countServices() {
    try {
      return this._embedded.sharedCustomersServices.length;
    } catch (e) {
      return 0;
    }
  }

  get canDelete() {
    return !(this.uuid && this.countAmo && this.countContacts);
  }

  get account_ids() {
    try {
      return this._embedded.sharedAmocrm.map(v => v.account_id);
    } catch (e) {
      return [];
    }
  }
}

export default SharedCustomers;
